export default {
    // 报警事件信息查询接口
    getAlarmType(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmType', params, response);
    },
    // 报警事件信息添加接口
    saveAlarmType(params, response) {
        if (params.sId == '') {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/addAlarmType', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/updateAlarmType', JSON.stringify(params), response);
        }
    },
    // 报警事件信息删除接口
    deleteAlarmType(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/deleteAlarmType', params, response);
    },
    // 获取报警类型下拉树
    getAlarmTypeTree(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getAlarmTypeTree', params, response);
    },
    // 校验名称是否重复
    checkRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/checkAlarmTypeRepeat', JSON.stringify(params), response);
    }
};
